<template>
  <div class="subitemMobile">
    <div v-for="(subitem, index) in subitems" :key="index">
      <h5 v-if="subitem.link == 'disable' || subitem.link == 'default'" class="subitemMobile__item">{{subitem.title}}</h5>
      <router-link @click.native="toggle" v-else class="subitemMobile__item" tag="div" :to="{name: subitem.link}">{{subitem.title}}</router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: 'adx-sidebar-subitem-mobile',
  components: {

  },
  props: {
    subitems: {
      required: false
    },
    parent: {
      required: false
    }
  },
  data() {
    return {
      selected: null
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    toggle() {
      this.$parent.toggle()
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>